import { FC, Suspense, useContext } from 'react';
import DefaultToolEnabled from '../../../toolsEnabled/DefaultToolEnabled';
import { BuildInAppToolId, IAppToolProps, IAppToolsContext } from '../../../types/appTools';
import AppToolsContext from '../../../context/AppToolsContext';
import Messages from '../../../../meetings/messages';
import AppTool from './AppTool';

const MessagesAppTool: FC<IAppToolProps> = ({ selectedApp }) => {
    const { eventUniqueName } = useContext<IAppToolsContext>(AppToolsContext);
    return (
        <DefaultToolEnabled appTool={BuildInAppToolId.Messages}>
            {({ isLoading, isEnabled }) => (
                <AppTool
                    selectedApp={selectedApp}
                    appTool={BuildInAppToolId.Messages}
                    isEnabled={isEnabled}
                    isLoading={isLoading}
                >
                    <Suspense fallback={null}>
                        <Messages eventUniqueName={eventUniqueName} />
                    </Suspense>
                </AppTool>
            )}
        </DefaultToolEnabled>
    );
};

export default MessagesAppTool;
